export enum RouteRecommendationTypeEnum {
  Unknown = 0,
  HomeToHome = 1,
  NearestTrainStationToNearestTrainStation = 2,
  NearestUndergroundStationToNearestUndergroundStation = 3,
  NearestOvergroundStationToNearestOvergroundStation = 4,
  NearestFerryToNearestFerry,
  HomeToOtherAddress = 6,
  OtherAddressToHome = 7,
  OtherAddressToOtherAddress = 8,
}
